import styled from 'styled-components';
import { color } from '@morressier/ts';

export const ToolTipWrapper = styled.div<{}>`
  position: relative;
  display: inline-block;
  margin-left: 8px;
`;

export const TextWrapper = styled.div<{}>`
  width: 100%;
  display: flex;
  justify-content: flex-start;
`;

export const ButtonWrapper = styled.div<{}>`
  padding-top: 30px;
  padding-bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const ToolTipContainer = styled.div<{ width: string; visible: boolean }>`
  position: relative;
  display: inline-block;
  width: ${props => props.width};
  visibility: ${props => (props.visible === true ? 'block' : 'hidden')};
  border: solid 1px ${color('grey')};
  background-color: ${color('white')};
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 9999;
  bottom: 150%;
  left: 25%;
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 20%;
    margin-left: 1px;
    border-style: solid;
    border-color: ${color('white')} transparent transparent transparent;
    border-width: 10px;
  }
  &::before {
    content: '';
    position: absolute;
    top: 100%;
    left: 20%;
    margin-left: 0px;
    border-style: solid;
    border-color: ${color('grey')} transparent transparent transparent;
    border-width: 12px;
  }
`;

export const ToolTipTitle = styled.p<{}>`
  font-size: 24px;
  margin-top: 16px;
  margin-left: 24px;
  font-weight: bold;
  color: ${color('secondaryBrand')};
`;

export const ToolTipText = styled.p<{}>`
  font-size: 16px;
  margin-right: 24px;
  margin-left: 24px;
  text-align: justify;
  padding-top: 8px;
  font-weight: 500;
  line-height: 1.5;
  color: ${color('secondaryBrand')};
`;
